import { useMemo } from 'react'
import useSwr from 'swr'
import { type Course, type SingleSessionResult } from '@mc/api'

export const useCourseOrSessionBySlug = (
  slug?: string | null,
  type?: 'course' | 'series' | 'camp' | string,
) => {
  const apiPath = useMemo(() => {
    if (!slug) {
      return null
    }

    if (type === 'camp') {
      return `/jsonapi/v1/camps/${slug}?include=trailer,instructors&deep=true`
    }

    return `/jsonapi/v1/courses/${slug}`
  }, [slug, type])

  const { data, error, isLoading } = useSwr<Course | SingleSessionResult>(
    apiPath,
  )

  return {
    contentBySlug: data,
    error,
    isLoading,
  }
}
